module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uploader-file",
    attrs: {
      "status": _vm.status
    }
  }, [_vm._t("default", [_c('div', {
    staticClass: "uploader-file-progress",
    class: _vm.progressingClass,
    style: (_vm.progressStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "uploader-file-info"
  }, [_c('div', {
    staticClass: "uploader-file-name"
  }, [_c('i', {
    staticClass: "uploader-file-icon",
    attrs: {
      "icon": _vm.fileCategory
    }
  }), _vm._v(_vm._s(_vm.file.name))]), _vm._v(" "), _c('div', {
    staticClass: "uploader-file-size"
  }, [_vm._v(_vm._s(_vm.formatedSize))]), _vm._v(" "), _c('div', {
    staticClass: "uploader-file-meta"
  }), _vm._v(" "), _c('div', {
    staticClass: "uploader-file-actions"
  }, [_c('span', {
    staticClass: "uploader-file-pause",
    on: {
      "click": _vm.pause
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "uploader-file-resume",
    on: {
      "click": _vm.resume
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "uploader-file-retry",
    on: {
      "click": _vm.retry
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "uploader-file-remove",
    on: {
      "click": _vm.remove
    }
  })])])], {
    file: _vm.file,
    list: _vm.list,
    status: _vm.status,
    paused: _vm.paused,
    error: _vm.error,
    response: _vm.response,
    averageSpeed: _vm.averageSpeed,
    formatedAverageSpeed: _vm.formatedAverageSpeed,
    currentSpeed: _vm.currentSpeed,
    isComplete: _vm.isComplete,
    isUploading: _vm.isUploading,
    size: _vm.size,
    formatedSize: _vm.formatedSize,
    uploadedSize: _vm.uploadedSize,
    progress: _vm.progress,
    progressStyle: _vm.progressStyle,
    progressingClass: _vm.progressingClass,
    timeRemaining: _vm.timeRemaining,
    formatedTimeRemaining: _vm.formatedTimeRemaining,
    type: _vm.type,
    extension: _vm.extension,
    fileCategory: _vm.fileCategory
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41655fd7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/file.vue
// module id = 74
// module chunks = 0